import Swal from "sweetalert2";
import api from "../../../utilities/interseptor";
const apiUrl = process.env.REACT_APP_API

export const getNotas = async (fecha_inicio, fecha_fin) => {
    try {
        const response = await api.get(`${apiUrl}/monitor/reportes/get-notas?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching notas:", error);
        throw error;
    }
}